var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-layout',{attrs:{"title":_vm.$t('Activity Log')},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('activity-log')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }